module.exports = __webpack_public_path__ + "img/icon-sports.96d235d1.png";